import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectStateReducerCreator } from '../types';

const setUpdatingSessionUuidReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state, action: PayloadAction<string | null>) => {
    // This is required to keep track of the session that is being updated
    // inside of save-session-middleware.ts
    state.updatedSessionUuid = action.payload;
  });
};

export default setUpdatingSessionUuidReducer;
